import { defineStore } from 'pinia'
import { login, logout, getUserProfile, register } from '@/api/user'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    userId: (state) => state.userInfo?.userId,
    nickname: (state) => state.userInfo?.nickname,
    avatar: (state) => state.userInfo?.avatar,
    role: (state) => state.userInfo?.role
  },

  actions: {
    async loginAction(loginForm) {
      const res = await login(loginForm)
      this.token = res.data.token
      this.userInfo = res.data
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('userInfo', JSON.stringify(res.data))
      return res
    },

    async registerAction(registerForm) {
      const res = await register(registerForm)
      this.token = res.data.token
      this.userInfo = res.data
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('userInfo', JSON.stringify(res.data))
      return res
    },

    async logoutAction() {
      try {
        await logout()
      } catch (error) {
        console.error('退出登录失败:', error)
      }
      this.token = ''
      this.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },

    async getUserInfoAction() {
      const res = await getUserProfile()
      this.userInfo = { ...this.userInfo, ...res.data }
      localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
      return res
    },

    setUserInfo(userInfo) {
      this.userInfo = { ...this.userInfo, ...userInfo }
      localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
    }
  }
})
